import { render, staticRenderFns } from "./SpecsTab.vue?vue&type=template&id=f48de02a&scoped=true&"
import script from "./SpecsTab.vue?vue&type=script&lang=js&"
export * from "./SpecsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f48de02a",
  null
  
)

export default component.exports